import { Place } from "@/types";
import http from "../common/axios";

export async function getPlace(id: number): Promise<Place> {
  const place = await http.get(`places/${id}`);

  return place.data as Place;
}

export async function getPlacesByGeohash(geohash: string) {
  const data = await http.get(`places/tile/${geohash}/list`);
  return data.data.data as Place[];
}

export async function getPlacesByQuery(query: string) {
  const data = await http.post(`places/search-new`, { term: query });
  return data.data.data as Place[];
}
